const lists = {
  SOFT_LAUNCH: '8337c14d81',
  TRANSACTIONAL: '049502e80e',
  OUT_OF_SERVICE_ZIP_CODE: '804625'
};

export const subscribe = (email, list, mergeFields) => {
  const args = {
    email,
    list: lists[list]
  };
  if (mergeFields) args.merge_fields = mergeFields;

  return fetch('https://www.theculinistas.com/api/mailchimp/subscribe', {
    method: 'POST',
    mode: 'no-cors',
    body: JSON.stringify(args)
  });
};

const MailChimp = {
  lists,
  subscribe
};

export default MailChimp;



// WEBPACK FOOTER //
// ./src/helpers/mailchimp.js